import {
  Flex,
  Heading,
  VStack,
  Text,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import { HomeCards } from "../components";
import Lottie from "react-lottie-player";
import learnLottie from "../assets/lottie/learning.json";
import { NavLink } from "react-router-dom";

const Home = () => {
  const lottieSize = useBreakpointValue({
    base: 250,
    sm: 300,
    md: 400,
    lg: 500,
    xl: 550,
  });

  return (
    <Flex flex="1" align="center" direction="column">
      <Flex
        align="center"
        justify="space-around"
        w="100%"
        flex="1"
        flexWrap="wrap"
        p="10px 20px"
      >
        <VStack textAlign="center" gap={"10px"} p="0 20px">
          <Heading
            color="primarytxt.900"
            size="2xl"
            marginTop={[7, 7, 7, 10, 0]}
          >
            The Ultimate Guide to Setback
          </Heading>
          <Text fontSize="lg">
            Your One-Stop-Shop for Rules, Strategies, Playing, and Tips
          </Text>
          <NavLink to="/about" style={{ marginTop: "30px" }}>
            <Button bg="bg.100" _hover={{ bg: "bg.200" }}>
              Learn More
            </Button>
          </NavLink>
        </VStack>
        <Lottie
          loop
          animationData={learnLottie}
          play
          style={{ width: lottieSize, height: lottieSize }}
        />
      </Flex>

      <HomeCards />
    </Flex>
  );
};
export default Home;
